import * as yup from 'yup';

export const hpaConverterValidationSchema = yup.object({
  enabled: yup.boolean().required(),
});
